module.exports = __webpack_public_path__ + "static/media/dashboard.2c8f831b.svg";